import { generatePath } from 'react-router-dom';

import { PagePaths } from '@/routes/page-paths';

const PENDING_REVIEW_DRAFT_STATUS = 'PendingReview';
const REVERIFICATION_PENDING_STATUS = 'ReVerificationPending';

export type EntityReviewState = {
  entityApprovalStatus?: string | null;
  draftStatus?: string | null;
};

export type EntityReviewAccess = EntityReviewState & { canReviewCrossEntity: boolean };

export function isEntityInReapprovalState({
  entityApprovalStatus,
  draftStatus,
}: EntityReviewState) {
  return (
    draftStatus === PENDING_REVIEW_DRAFT_STATUS ||
    entityApprovalStatus === REVERIFICATION_PENDING_STATUS
  );
}

export function canOpenEntityReviewRoute({ canReviewCrossEntity, ...state }: EntityReviewAccess) {
  return canReviewCrossEntity && isEntityInReapprovalState(state);
}

export function getManageEntityReviewOrEditPath({
  id,
  ...access
}: EntityReviewAccess & { id: string }) {
  const pattern = canOpenEntityReviewRoute(access)
    ? PagePaths.manageEntityReview
    : PagePaths.manageEntityId;

  return generatePath(pattern, { id });
}

export function shouldPersistOnNavigate(isReviewMode: boolean) {
  return !isReviewMode;
}
